export default "__VITE_ASSET__CCJGAN6w__"